import React from "react";
import { isValid } from "date-fns";
import PropTypes from "prop-types";
import ReviewComment from "./review-comment";
import { longDate } from "helpers/FormattingUtils";
import { hasUserData, userDataPropType, withUserData, isAdmin } from "components/source/hoc/with-user-data";
import ReviewStars from "../shared/review-stars";
import ReviewHSContent from "./review-hs-content";
import ProductInfoBar from "./user_specific_reviews_components/product-info-bar";
import IncentivizedReviewTag from "./incentivized-review-tag";

class ReviewContentComponent extends React.Component {
  static propTypes = {
    moment: PropTypes.shape({
      uploadedAt: PropTypes.any,
      reviewId: PropTypes.any,
      aggregateComments: PropTypes.string,
      rating: PropTypes.number,
      caption: PropTypes.string,
      content: PropTypes.any,
      fitFeedbackMap: PropTypes.object,
      isAnonymous: PropTypes.bool,
      isIncentivized: PropTypes.bool,
    }),
    submitComment: PropTypes.func.isRequired,
    userData: userDataPropType,
    product: PropTypes.object,
    isUserSpecificReview: PropTypes.bool,
  };

  state = {
    hasCurrentUser: false,
    showCommentForm: false,
  };

  componentDidMount() {
    this.setState({ hasCurrentUser: hasUserData(this.props.userData) });
  }

  componentDidUpdate() {
    const hasCurrentUser = hasUserData(this.props.userData);
    if (hasCurrentUser !== this.state.hasCurrentUser) {
      this.setState({ hasCurrentUser });
    }
  }

  formattedDate = inputDate => {
    const dateToProcess = isValid(new Date(inputDate)) ? inputDate : this.props.moment?.uploadedAt;
    if (!dateToProcess) return "";
    const date = new Date(dateToProcess);
    return isValid(date) ? longDate(date) : "";
  };

  displayCommentForm = () => {
    this.setState({ showCommentForm: true });
  };

  renderContent() {
    const { moment } = this.props;

    return (
      <>
        {!moment?.isAnonymous && <p className="review-text proxima-body-copy">{moment?.content}</p>}

        {this.isHSReview(moment) && this.hasFitFeedBackMap(moment) && (
          <ReviewHSContent fitFeedbackMap={moment.fitFeedbackMap} />
        )}
      </>
    );
  }

  /* HTML unescape/decoder - had a quick discussion on XSS with Ger, since we are replacing the string so we believe it should be fine */
  /* Src: stackoverflow - https://stackoverflow.com/questions/7394748/whats-the-right-way-to-decode-a-string-that-has-special-html-entities-in-it/7394787 */
  /* Src: js fiddle net - https://jsfiddle.net/Be2Bd/1/ (given in the stackoverflow abv)*/
  parseHtmlEnteties = inp => {
    return inp
      .replaceAll(/&#([0-9]{1,3});/gi, function (match, numStr) {
        var num = parseInt(numStr, 10); // read num as normal number
        return String.fromCharCode(num);
      })
      .replaceAll("&quot;", '"');
  };

  isHSReview = moment => {
    return !!moment?.happinessSurveyId;
  };

  hasFitFeedBackMap = moment => {
    return !!moment?.fitFeedbackMap && Object.keys(moment?.fitFeedbackMap).length !== 0;
  };

  commentForm = () => {
    if (!isAdmin(this.props.userData)) {
      return null;
    }

    let className;

    if (this.state.hasCurrentUser) {
      if (this.state.showCommentForm && this.props.submitComment) {
        return <ReviewComment reviewId={this.props.moment.reviewId} submitComment={this.props.submitComment} />;
      } else {
        if (Array.isArray(this.props.moment?.aggregateComments) && this.props.moment?.aggregateComments.length > 0) {
          className = "with-comments";
        }

        return (
          <div className={className}>
            <button className="standalone-link" onClick={this.displayCommentForm}>
              Comment
            </button>
          </div>
        );
      }
    }
  };

  render() {
    const { moment } = this.props;
    let starRating;

    if (moment?.rating) {
      starRating = (
        <div className="review-rating new-stars">
          <ReviewStars imageName={`BlackStars${Math.floor(moment.rating)}`} />
        </div>
      );
    }

    return (
      <div className="review-content flex flex-col justify-between" data-test-id="review-content">
        <div>
          {starRating}
          <div className="review-date label">{this.formattedDate()}</div>
          <div className="review-title dek-one">{moment?.caption}</div>
          {this.renderContent()}
        </div>

        {this.props.isUserSpecificReview && <ProductInfoBar productData={this.props.product} />}
        <IncentivizedReviewTag isIncentivized={moment?.isIncentivized} />
      </div>
    );
  }
}

export default withUserData(ReviewContentComponent);
